interface IAddress {
    street?: string;
    streetNumber?: string;
    addressSuffix?: string;
    city?: string;
    zip?: string;
    country?: string;
    region?: string;
    district?: string;
}
interface IPermissions {
    maySendChatMessages: boolean;
    maySendAndReceivePhoneCalls: boolean;
    maySendEmails: boolean;
    isEmergencyContact: boolean;
    hasKey: boolean;
}
interface IContact {
    externalContactId?: number;
    // id?: string;
    contactType?: string;
    avatar?: string;
    title?: string;
    firstname: string;
    lastname: string;
    nickname?: string;
    email: string;
    company?: string;
    phoneHome?: string;
    phoneMobile?: string;
    availabilityNotes?: string;
    additionalNotes?: string;
    medicalContactType?: string;
    relationToUser?: string;
    transitTime?: 0;
    address?: AddressDTO;
    permissions?: IPermissions;
}

export class ContactDTO implements IContact {
    externalContactId?: number;
    id?: number;
    // contactType?: string;
    avatar?: string;
    title?: string;
    firstname: string;
    lastname: string;
    nickname?: string;
    email: string;
    company?: string;
    phoneHome?: string;
    phoneMobile?: string;
    availabilityNotes?: string;
    additionalNotes?: string;
    medicalContactType?: string;
    relationToUser?: string;
    transitTime?: 0;
    address?: AddressDTO;
    permissions?: IPermissions;

    constructor(
        // externalContactId,
        title?,
        firstname?,
        lastname?,
        nickname?,
        email?,
        company?,
        phoneHome?,
        phoneMobile?,
        availabilityNotes?,
        additionalNotes?,
        medicalContactType?,
        relationToUser?,
        transitTime?,
        address?,
        permissions?,
    ) {
        // this.externalContactId = externalContactId;
        this.title = title;
        this.firstname = firstname;
        this.lastname = lastname;
        this.nickname = nickname;
        this.email = email;
        this.company = company;
        this.phoneHome = phoneHome;
        this.phoneMobile = phoneMobile;
        this.availabilityNotes = availabilityNotes;
        this.additionalNotes = additionalNotes;
        this.medicalContactType = medicalContactType;
        this.relationToUser = relationToUser;
        this.transitTime = transitTime;
        this.address = address;
        // this.permissions = permissions;
    }
}

export class AddressDTO implements IAddress {
    street?: string;
    streetNumber?: string;
    addressSuffix?: string;
    city?: string;
    zip?: string;
    country?: string;
    region?: string;
    district?: string;
    longitude?: number;
    latitude?: number;
    constructor(
        street?: string,
        streetNumber?: string,
        addressSuffix?: string,
        city?: string,
        zip?: string,
        country?: string,
        region?: string,
        district?: string,
        longitude?: number,
        latitude?: number,
    ) {
        this.street = street;
        this.streetNumber = streetNumber;
        this.addressSuffix = addressSuffix;
        this.city = city;
        this.zip = zip;
        this.country = country;
        this.region = region;
        this.district = district;
        this.longitude = longitude;
        this.latitude = latitude;
    }
}

class PermissionsDTO implements IPermissions {
    maySendChatMessages: boolean = true;
    maySendAndReceivePhoneCalls: boolean = true;
    maySendEmails: boolean = false;
    isEmergencyContact: boolean = false;
    hasKey: boolean = false;
}

export class ExternalContactAddressDTO extends AddressDTO {}

export class ExternalContactDTO extends ContactDTO {}

export class ExternalContactPermissonDTO extends PermissionsDTO {
    // constructor(
    //     maySendChatMessages: boolean,
    //     maySendAndReceivePhoneCalls: boolean,
    //     maySendEmails: boolean,
    //     isEmergencyContact: boolean,
    //     hasKey: boolean
    // ) {
    //     super();
    //     this.maySendChatMessages = maySendChatMessages;
    //     this.maySendAndReceivePhoneCalls = maySendAndReceivePhoneCalls;
    //     this.maySendEmails = maySendEmails;
    //     this.isEmergencyContact = isEmergencyContact;
    //     this.hasKey = hasKey;
    // }
}

// class ResidenceDTO {
//     type	string
// access	string
// notes	string
// keyNumber	string
// keySite	string
// }

// class	CohabitingSituationDT {
//     withPartner	boolean
// withChildren	boolean
// withOtherRelatives	boolean
// withDogs	boolean
// withCats	boolean
// withDangerousAnimals	boolean
// withHarmlessAnimals	boolean
// }

export class dsdaInternalContactDTO {
    userId: number;
    login: string;
    firstName: string;
    lastName: string;
    nickName: string;
    title: string;
    firstLanguage: string;
    colloqAdd: boolean;
    salutation: string;
    sex: string;
    maritalStatus: string;
    address;
    birthday: string;
    age: number;

    email: string;

    phoneHome: string;

    phoneMobile: string;

    phoneEmergencyNumber: string;

    waitUntilDisponentTalks: boolean;

    isAgent: boolean;

    userEmergencyId: string;

    interests: string;

    notesMedicalPreconditions: string;

    notesSocialEnvironment: string;

    actionForEmergencyCallWithoutVoice: string;
}

export class InternalContactPermissonDTO extends PermissionsDTO {
    mayEvaluateHealthData = false;
    mayAccessHealthData = false;
    mayChangeMedication = false;
    maySeeGeoPosition = false;
    mayUseDropinCalls = false;
}

export class InternalContactDTO extends ContactDTO {
    userId: number;
    // typeOfContact: TypeOfContact;
    // comment?: string;
    contactPermissions?: InternalContactPermissonDTO;
    // constructor() {
    //     super();
    // }
}

export class AddInternalContactDTO {
    contactUserId: number;
    typeOfContact: TypeOfContact;
    comment?: string;
    contactPermissions?: InternalContactPermissonDTO;
    constructor() {}
}

export enum TypeOfContact {
    CONTACT = 'CONTACT',
    CARETAKING = 'CARETAKING',
}

export enum ContactType {
    // CareTaker = 'My supervisor',
    // External = 'External contact',
    // Internal = 'Alpha contact',
    // Patient = 'My supervisor',
    CARE_ASSISTANT = 'CARE-ASSISTANT',
    EXTERNAL_CONTACT = 'EXTERNAL-CONTACT',
    INTERNAL_CONTACT = 'INTERNAL-CONTACT',
    PATIENT = 'PATIENT',
}

export class SimpleContactWithPermissionsAppDTO {
    // Contact short info, either internal or external

    // Either a userId or external contact id
    id: number;

    // The type of Id in the 'id' property
    // USER_ID, EXTERNAL_CONTACT_ID
    idType: string;

    // First name
    firstName: string;

    // Last name
    lastName: string;

    // Nickname
    nickName: string;

    // Title
    title: string;

    // email
    email: string;

    address: AddressDTO;

    // Phone Mobile
    phoneMobile: string;

    // Phone Home
    phoneHome: string;

    // May Send And Receive Phone Calls
    maySendAndReceivePhoneCalls: boolean;

    // May Use Drop In Calls
    mayUseDropInCalls: boolean;
}

export class SimpleContactAppDTO {
    // Contact short info, either internal or external

    // Either a userId or external contact id
    id?: number;

    // The type of Id in the 'id' property
    idType?: string;

    // The type of contact
    contactType: string;

    // First name
    firstName?: string;

    // Last name
    lastName?: string;

    // Nickname
    nickName?: string;

    // Title
    title?: string;

    // email
    email?: string;

    address?: AddressDTO;

    // Phone Mobile
    phoneMobile?: string;

    // Phone Home
    phoneHome?: string;

    avatar?: string;
}
